export const tsmtKommunikacioPlaybook = {
  seo: {
    title: "TSMT® online megjelenés playbook — TVTH tagoknak | Bespire",
    description:
      "TSMT® terapeuták és LongiKid® vizsgálók kommunikációs playbookja: Facebook, Google Cégprofil, jogi keretek — és hogy hogyan hozza mindezt könnyűvé a Bespire.",
  },
  hero: {
    eyebrow: "TVTH • Kommunikációs playbook",
    title: "TSMT® online megjelenés — az alapok kezdő szett",
    subtitle:
      "Egy gyakorlati útmutató TVTH tagoknak, hogy a Facebook és Google Cégprofil hitelesen, jogszerűen és a márka erejét kihasználva működjön. A Bespire pedig végig melletted áll, hogy mindezt tényleg meg is tudd csinálni heti 2–4 óra ráfordítással.",
    stats: [
      { value: "16", label: "Facebook lépés" },
      { value: "5", label: "Google lépés" },
      { value: "2–4h", label: "hetente marketingre" },
    ],
    ctaPrimary: "Ingyenes próba a Bespire-ban",
    ctaSecondary: "TSMT® partner oldal",
    disclaimer:
      "A playbook a TSMT® Modell csapatának hivatalos anyaga alapján készült. TVTH tagként a TSMT® és LongiKid® márkanevet és logót jogosult vagy használni.",
  },
  goldenRules: {
    eyebrow: "Aranyszabályok",
    title: "A legfontosabb keretek, mielőtt bármit posztolnál",
    subtitle:
      "Ezek a szabályok végigkísérik a teljes playbookot. Ha csak ezeket megjegyzed, már a hitelesség 80%-át megnyerted.",
    items: [
      {
        title: "Az a bizonyos ®",
        description:
          "A TSMT® és LongiKid® védjegyoltalom alatt állnak. TVTH tagként — a tagdíj megfizetésével — jogosult vagy használni a nevet, a logót és a márka értékét. Ez országosan ismert brand nagy központi eléréssel, így az ismertséget és hitelességet a saját vállalkozásod javára tudod kamatoztatni.",
        highlight: "TSMT® és LongiKid® — mindig ®-al ellátva.",
      },
      {
        title: "Hivatalos logók",
        description:
          "Képeken és infografikákon kizárólag a hivatalos TSMT® és LongiKid® logót használd. A LongiKid® új logóját 2026 nyarán vezeti be a központ — 2026 ősz végére mindenhol lecserélik, és téged is kérnek, hogy addigra álljon át. A saját logódat természetesen szabadon használhatod a hivatalosak mellett.",
        highlight: "Saját logó szabadon, TSMT®/LongiKid® csak hivatalos verzióban.",
      },
    ],
    logoConsequencesTitle: "Miért fontos ez? Ha nem a hivatalos logót használod…",
    logoConsequences: [
      "A szülők azt gondolják, hogy ez egy «mókesz» cég — elveszted a bizalmat.",
      "Elesel attól, hogy a bevésődött, ismert logó előnyt és hitelességet építsen számodra.",
      "Csökken a profizmus érzése — pedig ez ma már alapelvárás.",
      "Ha észrevesszük, meg fogunk kérni, hogy javítsd — plusz kör, ami elkerülhető.",
    ],
    bespireTie: {
      title: "Mit segít a Bespire?",
      description:
        "A Bespire segít egységes, professzionális megjelenést kialakítani az online jelenlétedhez, hogy a hitelesség és a márka értéke minden felületen megmaradjon.",
      linkLabel: "Hivatalos logó letöltése",
    },
  },
  childrenInVideo: {
    eyebrow: "Kényes téma",
    title: "Gyerekek a videóban",
    subtitle:
      "Egy nagyon kényes téma — de tiszta keretek mellett bátran posztolhatsz. A legrosszabb, ami történhet: megkérnek, hogy módosíts. Szóval csak bátran!",
    legalNotice: {
      label: "Ajánlott zárómondat a leírás végére (ha gyermek szerepel a felvételen):",
      text:
        "A videóban látható gyakorlatok kizárólag szemléltetési és edukációs célokat szolgálnak, nem helyettesítik az egyéni vizsgálatot vagy szakmai tanácsadást. A felvételen szereplő gyermekek törvényes képviselői a képmás és hang rögzítéséhez, valamint a videó kommunikációs célú közzétételéhez előzetesen írásban hozzájárultak. A felvétel engedély nélküli másolása és továbbfelhasználása tilos.",
    },
    doList: {
      title: "Mit szabad",
      items: [
        "Kérj mindig írásos szülői hozzájárulást a képmás rögzítéséhez és közzétételéhez.",
        "Ha nincs engedély, a gyermek ne legyen felismerhető (hátulról, arc kitakarva, rajz vagy illusztráció).",
        "Reális, otthon is megvalósítható feladatokat mutass — a szülő higgye el, hogy ő is meg tudja csinálni.",
        "LongiKid® vizsgálatból csak részleteket, a «miértre» fókuszálva — a szülő biztonságérzetét építve.",
      ],
    },
    dontList: {
      title: "Mit tilos",
      items: [
        "Teljes LongiKid® vizsgálati sort elejétől a végéig felvenni.",
        "LongiKid® alaplapokat befotózni — csak pillanatképek adatlap nélkül.",
        "TSMT® rajzolt feladatsort posztolni — helyette pár feladat kiemelése ok.",
        "Beleegyezés nélkül szülőt vagy gyereket posztolni.",
        "Fejjel lefelé és extrém vesztibuláris ingereket tartalmazó gyakorlatokat.",
        "LongiKid® vizsgálati véleményt személyes adatokkal vagy beazonosítható tünettel.",
      ],
    },
    additional: {
      title: "További javaslatok",
      items: [
        {
          title: "TSMT® eszközös feladatok",
          body:
            "Billenőlapos vagy nagylabdás feladatot bátran bemutathatsz — a fenti tiltásokat figyelembe véve, mindig megfelelő magyarázattal.",
        },
        {
          title: "LongiKid® vélemények",
          body:
            "Csak személyes adatok nélkül és olyan kísérő szöveggel, amiből nem lehet kitalálni, ki volt az alany. Ne írd le a pontos dátumot, és kerüld a nagyon leszűkítő tünetegyütteseket — szűk közösségben így is felismerhetik.",
        },
      ],
    },
    escalationTitle: "Mit tegyél kritikus kommenttel?",
    escalation:
      "Ha kritikus kommentet kapsz, és az NEM TVTH terapeutától vagy TSMT® oktatótól jön, saját hatáskörben kezeled. Ha a fenti irányelvek szerint véleményes lett a videó, a szakmai.vezeto@tsmtmodell.hu címen jelezheted a központnak.",
    bespireTie: {
      title: "Mit segít a Bespire?",
      description:
        "A Bespire segít a gyermekvédelmi és jogi keretek figyelembe vételében, hogy a tartalmaid biztonságosan és megfelelően készülhessenek.",
    },
  },
  facebook: {
    eyebrow: "Facebook",
    title: "Professzionális szakmai oldal — 16 lépésben",
    subtitle:
      "Az útmutató TSMT® terapeutáknak készült, akik hiteles, bizalomépítő és jogszabálynak megfelelő jelenlétet akarnak. Nem az a cél, hogy tökéletes legyél elsőre — hanem hogy elindulj.",
    pageNames: {
      title: "Oldal neve",
      subtitle:
        "Facebook → Menü → Oldalak → Új oldal létrehozása. A név = neved + TSMT + helyszín. A többi információ mehet a leírásba. (A Facebook sajnos nem engedi a ® szimbólum használatát az oldalnév mezőben.)",
      good: [
        "Kovács Anna TSMT terapeuta",
        "Kovács Anna – Okleveles TSMT terapeuta",
        "TSMT Fejlesztés – Győr – Kovács Anna",
      ],
      bad: ["Legjobb TSMT", "ADHD Gyógyító", "Garantált fejlődés"],
      goodLabel: "Javasolt",
      badLabel: "Kerüld",
    },
    coverExample: {
      title: "Borítókép, ami 3 másodperc alatt elmond mindent",
      subtitle:
        "Mivel foglalkozol • kiknek segítesz • hogyan lehet jelentkezni. Egy jó példa:",
      lines: [
        "TSMT® terapeuta",
        "Csecsemő- és gyermekfejlesztés",
        "Vizsgálat • Terápia • Szülőkonzultáció",
        "📍 Budapest XVII.",
      ],
    },
    steps: [
      {
        n: "01",
        title: "Miért ne a saját profilodat használd?",
        body: "A személyes profil és a szakmai tevékenység két külön dolog. Szakmai oldalon:",
        list: [
          "Professzionális megjelenés",
          "Kereshető a Google-ben",
          "Hirdetések futtathatók",
          "Statisztikák érhetők el",
          "Több admin kezelheti",
          "Nem kell ismerőssé jelölni a követőket",
          "Megfelel a Meta ajánlásainak",
        ],
      },
      {
        n: "02",
        title: "Oldal létrehozása",
        body:
          "Facebook → Menü → Oldalak → Új oldal létrehozása. A név = neved + TSMT + helyszín. Konkrét javaslatokat és kerülendő neveket lásd fentebb a «Név javaslatok» blokkban.",
      },
      {
        n: "03",
        title: "Profilkép",
        body: "Mindig jó minőségű. Lehetőleg mosolygós, természetes, világos háttér, szakmai öltözet.",
        list: ["Ne használj szelfit", "Ne használj nyaralós képet", "Ne használj családi fotót", "Ne használj gyerekekkel közös képet"],
      },
      {
        n: "04",
        title: "Borítókép",
        body:
          "3 másodperc alatt mondja el: mivel foglalkozol, kiknek segítesz, hogyan lehet jelentkezni. Konkrét példa a fenti «Borítókép» blokkban.",
      },
      {
        n: "05",
        title: "Bemutatkozás",
        body:
          "Legyen rövid. Légy kreatív, itt tudod a saját hangodat megmutatni — akár gyakori kérdéseket is feltehetsz. Legyen személyes, ne általános.",
        badExampleLabel: "Kerüld (AI-generált, általános):",
        badExample:
          "TSMT® terapeuta vagyok. Kisgyermekek mozgás-, figyelem- és idegrendszeri fejlődésének támogatásával foglalkozom. Célom, hogy a családok időben kapjanak segítséget és szakmai támogatást.",
        goodExampleLabel: "Sokkal jobb (személyes, kérdéssel):",
        goodExample:
          "«Miért nem beszél még? A többi gyerek már szalad, ő miért nem?» Ilyen és hasonló kérdésekben segítek a hozzám forduló szülőknek.",
      },
      {
        n: "06",
        title: "Kapcsolati adatok",
        body:
          "Mindig töltsd ki, különben nem találnak meg, és az előző 5 pont a kukába megy :)",
        list: ["Telefonszám", "E-mail", "Honlap", "Cím", "Messenger"],
        footer: "Minél több elérhetőség, annál nagyobb a bizalom.",
      },
      {
        n: "07",
        title: "Gomb beállítása",
        body: "Ajánlott gombok, amit érdemes választani:",
        list: [
          "Kapcsolatfelvétel",
          "Időpontfoglalás",
          "Üzenet küldése — ha ezt választod, adj meg idősávot, hogy megmaradjon a privát szférád és ne égj ki.",
        ],
      },
      {
        n: "08",
        title: "Mit posztolj?",
        body:
          "Hüvelykujj szabály — bátran igazíts rajta: 40% edukáció, 30% bizalomépítés, 20% közösség, 10% szolgáltatás. Részletes bontás alább.",
      },
      {
        n: "09",
        title: "Képek",
        body: "A képek adják a poszt első benyomását — figyelj a minőségre.",
        useLabel: "Használj",
        use: [
          "Saját fotókat — nem kell műterem, sőt.",
          "Infografikákat (később megmutatjuk, hogyan).",
          "Illusztrációkat.",
          "TVTH tagként a hivatalos TSMT® és LongiKid® logót.",
        ],
        avoidLabel: "Kerüld",
        avoid: [
          "Túl sok stock fotót — nagyon személytelen.",
          "Pixeles, rossz minőségű képet — ez már alapelvárás, nem prémium.",
        ],
      },
      {
        n: "10",
        title: "Videók (a mumus :D)",
        body:
          "A Facebook jelenleg a videókat részesíti előnyben — a fenti dolgokat is akkor tudod jól kihasználni, ha ezen a ponton dolgozol.",
        recommendedLabel: "Ajánlott",
        recommended: [
          "30–90 másodperc hosszú",
          "Az elején legyen horog üzenet (hook), ami megragadja a figyelmet",
          "Legyél spontán és emberi — nem baj, ha bakizol kicsit 🙂",
        ],
        topicsLabel: "Témaötletek",
        topics: [
          "Fejlesztő játék",
          "Egyensúly",
          "Figyelem",
          "Iskolaérettség",
          "Szenzoros feldolgozás",
          "LongiKid® felmérés célja, eredménye",
          "Esetek, sztorik",
        ],
      },
      {
        n: "11",
        title: "Kommentek kezelése",
        body:
          "Mindig válaszolj, ha teheted — ez is az oldal célja. Ideálisan 24 órán belül. Amit semmiképp ne csinálj: ne diagnosztizálj vagy adj véleményt kommentben.",
        templateLabel: "Ehelyett használd ezt a sablonválaszt:",
        template:
          "«Köszönöm a kérdést! Minden gyermek más, ezért ennyi információ alapján nem lehet felelősen véleményt mondani. Ha szeretné, keressen bizalommal, és megbeszéljük a részleteket.»",
      },
      {
        n: "12",
        title: "Amit érdemes kerülni",
        body: "Sose ígérj:",
        avoid: [
          "Biztos eredményt",
          "Garantált fejlődést",
          "Gyógyulást",
          "«Elmúlik az ADHD»",
        ],
        footer: "…és hasonló dolgokat (nyilvánvaló, de jobb leírni :))",
      },
      {
        n: "13",
        title: "Gyerek fotók",
        body: "Mindig legyen írásos szülői hozzájárulás. Ha nincs, a gyermek ne legyen felismerhető.",
        alternativesLabel: "Praktikus alternatívák, ha nincs engedély",
        alternatives: ["Hátulról fotózva", "Arc kitakarva", "Rajz vagy illusztráció"],
      },
      {
        n: "14",
        title: "Hashtagek",
        body:
          "Nem tudjuk pontosan mennyire működik az új algoritmus mellett — de olyan, mint a WC papír… ha nincs, akkor lehet baj 🙂 Használj ilyeneket:",
        hashtags: [
          "#TSMT",
          "#gyermekfejlődés",
          "#iskolaérettség",
          "#szenzorosfeldolgozás",
          "#korafejlesztés",
        ],
      },
      {
        n: "15",
        title: "Posztolási gyakoriság",
        body:
          "A lényeg egy folyamatos tartalom-gyártási szokás — heti 2–4 óra marketingre. A minimum, amivel már haladsz:",
        list: [
          "Heti 2–3 poszt",
          "Heti 1 videó",
          "Napi Story (ha van rá lehetőség) — ez átmegy Instagramra is",
        ],
      },
      {
        n: "16",
        title: "Átvett tartalom",
        body:
          "A TSMT® Modell oldaláról bármely tartalmat átveheted és saját gondolataiddal kiegészítheted.",
        sourceLabel: "Ha lementett képet posztolsz sajátként, tüntesd fel a forrást:",
        sourceUrl: "facebook.com/tsmtmodell",
      },
    ],
    postMix: {
      title: "Poszt-mix — a hüvelykujj szabály",
      items: [
        { pct: 40, label: "Edukáció", desc: "Mi a TSMT®? Mire jó? Mikor érdemes vizsgálatra menni?" },
        { pct: 30, label: "Bizalomépítés", desc: "Tornaterem, saját munka, szülői beszámolók (ütős!)." },
        { pct: 20, label: "Közösség", desc: "Események, workshopok, előadások." },
        { pct: 10, label: "Szolgáltatás", desc: "Vizsgálat, jelentkezés, időpontok." },
      ],
    },
  },
  bespireXsteps: {
    eyebrow: "Bespire × 16 lépés",
    title: "Mit vesz le a válladról a Bespire?",
    subtitle:
      "A playbook szabályaira épített funkciók — hogy ne csak elolvasd, hanem tényleg végig is csináld.",
    items: [
      { step: "06", stepTitle: "Elérhetőségek könnyedén", body: "A Bespire segít, hogy minden felületen következetesen szerepeljenek a kapcsolati adataid, így a szülők biztosan megtalálnak." },
      { step: "07", stepTitle: "Időpontfoglalás gomb", body: "A Facebook «Időpontfoglalás» gombhoz a Bespire foglalási linkedet kösd — a szülő 3 kattintással kap időpontot." },
      { step: "08", stepTitle: "Poszt-mix 40/30/20/10", body: "Az AI asszisztens ütemtervet készít az arány szerint Facebook, Instagram és TikTok platformokra." },
      { step: "11", stepTitle: "Kommentek 24h", body: "Üzenet-központ értesít, hogy ne csússz ki a 24 órás válaszablakból — sablonválaszok is előkészítve. (Hamarosan)" },
      { step: "09", stepTitle: "Képek és infografikák", body: "Pillanatok alatt készítesz professzionális posztképeket és infografikákat — nem kell külön grafikushoz fordulnod." },
      { step: "14", stepTitle: "Hashtag-könyvtár", body: "TSMT® és LongiKid® specifikus hashtag-csomagok, amiket egy kattintással a poszthoz fűzöl." },
      { step: "15", stepTitle: "Story cross-posting", body: "Egy Story felkerül Facebookra és Instagramra is — nem kell kétszer feltöltened." },
      { step: "10", stepTitle: "Videó ötletek és forgatókönyv", body: "Az AI asszisztens témajavaslatokat és rövid forgatókönyveket ad a 30–90 másodperces videóidhoz, horog üzenettel együtt." },
      { step: "08", stepTitle: "Tartalomnaptár", body: "Egy áttekinthető naptárban látod a következő heteid posztjait — sosem futsz ki ötletből, és nem posztolsz össze-vissza." },
      { step: "16", stepTitle: "Weboldal és foglalás egyben", body: "A Facebookról és Google-ből érkező szülők azonnal egy hiteles weboldalra jutnak, ahol foglalhatnak is — nem kell külön rendszert üzemeltetned." },
    ],
  },
  google: {
    eyebrow: "Google Térkép",
    title: "Google Cégprofil — 5 lépés",
    subtitle:
      "A szülők és intézményi szakértők keresésénél még mindig a Google az első. Ha ott nem vagy fent, láthatatlan vagy.",
    steps: [
      {
        title: "Hozz létre egy Google Cégprofilt",
        description:
          "A Google Cégprofil (Google Business Profile) segítségével a rendelőd megjelenhet a Google Keresőben és a Térképen.",
        substeps: [
          "Nyisd meg a business.google.com oldalt.",
          "Jelentkezz be a Google-fiókoddal (Gmail). Ha még nincs, hozz létre egyet.",
          "Kattints a «Vállalkozás hozzáadása» gombra.",
          "Add meg a nevet — érdemes a saját nevedet és a szakmai megnevezést használni.",
          "Válaszd ki a tevékenységedhez legjobban illő kategóriát.",
        ],
        nameExamplesLabel: "Név javaslatok",
        nameExamples: ["Kiss Anna – TSMT® terapeuta", "Kiss Anna – LongiKid® vizsgáló"],
        categoryLabel: "Kategória példák",
        categories: ["Fejlesztőközpont", "Egészségügyi szolgáltató", "Foglalkozási terapeuta"],
      },
      {
        title: "Add meg a legfontosabb adatokat",
        description:
          "Pontos cím, telefonszám, weboldal (ha van), nyitvatartás. Ha van Bespire weboldalad, azt add meg — így egyszerre kap SEO-erőt és foglalási funkciót.",
      },
      {
        title: "Tölts fel képeket",
        description:
          "Jó minőségű fotók a rendelőről, fejlesztő teremről, logóról és saját portrédról — ugyanazok, amiket a Facebookra és a Bespire oldaladra is felraktál.",
      },
      {
        title: "Írj bemutatkozást",
        description:
          "Mutasd be röviden, mivel foglalkozol, és említsd meg természetes módon a TSMT® és/vagy LongiKid® szolgáltatásaidat. Kulcsszavak: gyermekfejlesztés, iskolaérettség, szenzoros integráció.",
      },
      {
        title: "Igazold a profilodat",
        description:
          "A Google videós ellenőrzéssel, e-mailben vagy más módon igazolja a vállalkozást. Csak igazolás után jelenik meg a profil a Google Térképen.",
      },
    ],
    bespireTie: {
      title: "Egységes online jelenlét",
      description:
        "A Bespire segít, hogy a weboldalad, a kapcsolati adataid és a foglalási lehetőségeid minden platformon következetesen szerepeljenek — így a szülők és partnerek mindig pontos információt találnak.",
    },
  },
  checklist: {
    eyebrow: "Ellenőrzőlista",
    title: "Mielőtt élesítesz — pipáld végig",
    subtitle: "A playbook 6 pontja + 5 Bespire-extra, hogy ne csak elinduljon, hanem folyamatosan működjön is az online jelenléted.",
    playbookLabel: "Playbook alapok",
    playbook: [
      "Google Cégprofil létrehozva",
      "Profil igazolva",
      "Telefonszám és cím kitöltve",
      "Bemutatkozás elkészült",
      "Képek feltöltve",
      "Az adatok minden online felületen egységesek",
    ],
    bespireLabel: "Bespire-extra",
    bespire: [
      "Saját weboldal élesítve — szolgáltatások, árak, galéria, kapcsolat egy helyen",
      "Online foglalás bekötve — a Facebook «Időpontfoglalás» gombra és a Google Cégprofilba is",
      "Első AI-generált posztok ütemezve Facebookra és Instagramra",
      "Automata visszaigazoló és emlékeztető e-mailek beállítva a foglalásokhoz",
      "Ügyfelek és érdeklődők egy helyen — előzményekkel, jegyzetekkel, státusszal",
    ],
  },
  cta: {
    eyebrow: "Zárás",
    title: "Csináljuk együtt — bátran posztolj",
    subtitle:
      "Reméljük, hogy a fentiek segítenek megalapozni az online jelenlétedet és a napi jelenlétre megadják a megfelelő kereteket és muníciót. A Bespire pedig ott lesz melletted, hogy tényleg végig is tudd csinálni — weboldal, foglalás, AI asszisztens egy helyen.",
    primary: "Ingyenes próba — 3 nap, 30 kredit ajándékba",
    secondary: "TSMT® partner oldal",
    tertiary: "Webinárium jelentkezés",
    signoff: "Hajrás és sok sikert! — TSMT® Modell csapata",
    source:
      "Forrás: TSMT® Modell csapata — TVTH kommunikációs playbook. © 2023-2026 TSMT-HRG College Kft. Minden jog fenntartva.",
  },
};
